import "./polyfills";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { preloadCriticalFonts, optimizeFontDisplay } from "./utils/fontLoader";
import { preloadCriticalResources } from "./utils/serviceWorker";
import { initMobileOptimizations } from "./utils/mobileOptimizations";
import { initPerformanceMonitoring } from "./utils/performanceMonitor";

// Import test functions for development - removed to clean up console
// import './firebase/testTicketFilters';

// Detect if we are running in react-snap
const isReactSnap = navigator.userAgent === "ReactSnap";

// Optimize font loading
preloadCriticalFonts();
optimizeFontDisplay();

// Register service worker and preload resources only if not in react-snap and in production
if (!isReactSnap && process.env.NODE_ENV === "production") {
  preloadCriticalResources();
}

// Clear any existing service workers that might be causing issues
if ("serviceWorker" in navigator && !isReactSnap) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (let registration of registrations) {
      registration.unregister();
    }
  });

  // Clear all caches
  if ("caches" in window) {
    caches.keys().then(function (names) {
      for (let name of names) {
        caches.delete(name);
      }
    });
  }
}

// Initialize mobile optimizations
initMobileOptimizations();

// Initialize performance monitoring
initPerformanceMonitoring();

const rootElement = document.getElementById("root") as HTMLElement;

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
